import './process-polyfill';

import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import App from './App.jsx';
import {AppThemeProvider} from './theme.jsx';
import {AuthProvider} from './context/AuthContext.jsx';
import './index.css';
import {AlertProvider} from "./context/AlertContext";
import { initMuiXLicense } from './muiXLicense.js';
import AppErrorBoundary from './components/common/AppErrorBoundary.jsx';

initMuiXLicense();

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <AppThemeProvider key={'apptheme'}>
            <AppErrorBoundary>
                <BrowserRouter key={'approuter'}>
                    <AuthProvider key={'appauth'}>
                        <AlertProvider key={'appalert'}>
                            <App key={'appv2'}/>
                        </AlertProvider>
                    </AuthProvider>
                </BrowserRouter>
            </AppErrorBoundary>
        </AppThemeProvider>
    </React.StrictMode>
);
